// Dependencies
import React from 'react';
import { NavLink } from 'react-router-dom';

// Assets
import './BottomMenuBar.css';

// Constants
import { LEFT_PANE } from '../constants';


const BottomMenuBar = () => (
  <div className="BottomMenuBar d-flex justify-content-center align-items-center">
    <NavLink className="BottomMenuBarOption d-flex"
      to={{
        pathname: '',
        hash: LEFT_PANE.HASH_LINK.LISTING,
        state: { fromBottomMenuBar: true, selectedListOption: true }
      }}
      isActive={(match, location) => location.hash === LEFT_PANE.HASH_LINK.LISTING}
    >
      <span className="icon-list" />LIST
    </NavLink>

    <div className="BottomMenuBarDivider" />

    <NavLink className="BottomMenuBarOption d-flex"
      to={{
        pathname: '',
        hash: LEFT_PANE.HASH_LINK.MAP,
        state: { fromBottomMenuBar: true, selectedMapOption: true }
      }}
      isActive={(match, location) => location.hash === LEFT_PANE.HASH_LINK.MAP}
    >
      <span className="icon-map" />MAP
    </NavLink>
  </div>
);

export default BottomMenuBar;
